import { BasePlacement, Placement } from '@popperjs/core';

const BASE_PLACEMENTS: { [key: string]: BasePlacement } = {
  TOP: 'top',
  BOTTOM: 'bottom',
  RIGHT: 'right',
  LEFT: 'left',
};

export const PLACEMENTS: { [key: string]: Placement } = {
  ...BASE_PLACEMENTS,
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end',
};

export const VARIANTS = {
  LIGHT: 'light',
  DARK: 'dark',
};

type Theme = typeof VARIANTS;
export type ThemeVariant = Theme[keyof Theme];

export const getMainAxisPlacement = (placement?: Placement): BasePlacement => {
  switch (placement) {
    case BASE_PLACEMENTS.LEFT:
    case PLACEMENTS.LEFT_START:
    case PLACEMENTS.LEFT_END:
      return BASE_PLACEMENTS.LEFT;
    case PLACEMENTS.RIGHT:
    case PLACEMENTS.RIGHT_START:
    case PLACEMENTS.RIGHT_END:
      return BASE_PLACEMENTS.RIGHT;
    case PLACEMENTS.TOP:
    case PLACEMENTS.TOP_START:
    case PLACEMENTS.TOP_END:
      return BASE_PLACEMENTS.TOP;
    case PLACEMENTS.BOTTOM:
    case PLACEMENTS.BOTTOM_START:
    case PLACEMENTS.BOTTOM_END:
    default:
      return BASE_PLACEMENTS.BOTTOM;
  }
};
